import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText } from 'data/components';
import { updateProductField } from '../../../../../../data/Products/actions';

class SDM17DECDetail extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        switchState: PropTypes.string,
        planningMode: PropTypes.string,
        defaultSwitchState: PropTypes.string
    };

    static defaultProps = {
        planningMode: null,
        switchState: false,
        defaultSwitchState: false
    };

    render() {
        const { classes, switchState, defaultSwitchState, planningMode } = this.props;
        return (
            <FHEContainerForm>
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.switchState')}
                            itemContent={switchState}
                            classContent={switchState === 'OFF' ? classes.offColor : classes.onColor}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.defaultSwitchState')}
                            itemContent={defaultSwitchState}
                            classContent={defaultSwitchState === 'OFF' ? classes.offColor : classes.onColor}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningMode')}
                            itemContent={Translator.translate(`general.productModules.${planningMode}`)}
                        />
                    </Grid>
                </Grid>
            </FHEContainerForm>
        );
    }
}
function mapStateToProps(state, props) {
    const productKey = props.productKey;
    const product = state.environments.fhe.data.Products.getIn(['list', productKey], new Map());
    return {
        profile: state.data.user,
        productKey: productKey,
        productType: product.get('productType'),
        type: product.get('type'),
        planningMode: product.get('planningMode'),
        switchState: product.get('switchState'),
        defaultSwitchState: product.get('defaultSwitchState')
    };
}

const styles = theme => ({
    onColor: {
        color: theme.palette.success.main
    },
    offColor: {
        color: theme.palette.error.main
    }
});
export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ updateProductField }, dispatch)
    )(withStyles(styles, { withTheme: true })(SDM17DECDetail))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/Product/SmartPlug/SDM17SPG/index.js